import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_IGACOMBOS_SUCCESS = 'GET_IGACOMBOS_SUCCESS';
export const GET_IGACOMBOS_FAILURE = 'GET_IGACOMBOS_FAILURE';

function receive(igaSubClassificationsCombos) {
  return {
    type: GET_IGACOMBOS_SUCCESS,
    igaSubClassificationsCombos
  };
}

function reject() {
  return {
    type: GET_IGACOMBOS_FAILURE
  };
}

export function getIgaSubClassificationCombos() {
  return (dispatch) => {
    const promise = () => ApiService
      .getIgaSubClassificationCombos()
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response) {
          ApiService.addQueuedPromise(promise, error);
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, reject, false));
        }
      });
    return promise();
  };
}
